import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import RightDrawer from '../../../../components/customElements/RightDrawer/RightDrawer'
import { getImageSrc } from '../../../../helpers/getImageSrc'
import { useInvalidateQueries } from '../../../../hooks/useInvalidateQueries'
import { resetToCreatedGroup } from '../../../../services/ApiService'
import { notifySuccess } from '../../../../services/ToastifyService/ToastifyService'
import {
  closeModalFn,
  openModalFn,
} from '../../../../utils/controllers/ModalController'
import { getComp } from '../../../../utils/utils/DI'
import { requestsPaginationStore } from '../../RequestsSecondOperator/Table/hooks/useRequestsData'
import { adminRequestsCheckboxStore } from '../../pages/AdminRequestsPage'
import { newAssignDealerDrawerStore } from '../MassOperationDrawer/NewAssignDealerDrawerStore'

const NewResetToCreateDrawer = () => {
  const statusesStore = getComp('StatusesStore')
  const intl = useIntl()
  const [value, setValue] = React.useState<number[]>([])
  const invalidate = useInvalidateQueries()
  const { isResetToCreateOpen, setIsResetToCreateOpen } =
    newAssignDealerDrawerStore
  const statuses = statusesStore.orderStatuses.filter((el: any) => el.id === 1)

  const { mutateAsync } = useMutation({
    mutationKey: ['resetToCreatedGroup'],
    mutationFn: () =>
      resetToCreatedGroup({
        orderIds: adminRequestsCheckboxStore.selectedIds,
      }),
    onSuccess: () => {
      invalidate(['requests-table'])
      onClose()
      setValue([])
      closeModalFn['progress-backdrop']?.()
      requestsPaginationStore.resetSelectedRow()
      adminRequestsCheckboxStore.resetAll(true)
      notifySuccess('Заявки переведены в статус "Создана"')
    },
    onError: () => {
      closeModalFn['progress-backdrop']?.()
    },
  })

  const handleClick = async () => {
    openModalFn['progress-backdrop']?.()
    await mutateAsync()
  }

  const onClose = () => {
    setIsResetToCreateOpen(false)
  }

  return (
    // @ts-ignore
    <RightDrawer
      open={isResetToCreateOpen}
      onClose={onClose}
      titleComp={
        <Box className={'fx-col'}>
          <Typography variant={'subtitle1'} color={'common.white'}>
            <FormattedMessage id={'Заявок выбрано'} />:{' '}
            {adminRequestsCheckboxStore.selectedIds.length}
          </Typography>
          <Typography variant={'body1'} color={'#8FBFF6'}>
            <FormattedMessage id={'Перевод заявок в статус "Создана"'} />
          </Typography>
        </Box>
      }
    >
      <React.Fragment>
        <Box mb={3} mt={2} mx={2}>
          <Typography variant={'h6'} sx={{ fontSize: '14px' }}>
            <FormattedMessage id={'Изменить статус'} />
          </Typography>
        </Box>
        <Box mt={2} mx={2} sx={{ display: 'flex' }}>
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>
              <FormattedMessage id={'Статус'} />
            </InputLabel>
            <Select
              value={value}
              label={intl.formatMessage({ id: 'Статус' })}
              onChange={(event) => setValue(event.target.value as number[])}
            >
              {statuses.map((el: any) => (
                <MenuItem value={el.id} key={el.id}>
                  <Box className={'aln-center'}>
                    <img alt={''} src={el.imageSrc} />
                    <Box ml={1}>
                      <Typography variant={'subtitle2'}>{el.name}</Typography>
                    </Box>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {value.length !== 0 && (
            <Box className={'aln-center'} ml={1.5}>
              <IconButton onClick={handleClick}>
                <img alt={'Подтвердить'} src={getImageSrc('check')} />
              </IconButton>
              <IconButton onClick={() => setValue([])}>
                <img
                  alt={'Отменить'}
                  src={getImageSrc('close-dark')}
                  width={20}
                  height={20}
                />
              </IconButton>
            </Box>
          )}
        </Box>
      </React.Fragment>
    </RightDrawer>
  )
}

export default observer(NewResetToCreateDrawer)
